export default {
  RUN_ORGANIZATION_CHART_REPORT_EMBED:
    'location:run-organization-chart-report-embed',
  REDRAW_ORG_CHART: 'location:redraw-org-chart',
};
